import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchUserAttributes } from 'aws-amplify/auth';
import { ArrowRight } from 'lucide-react';

const links = [
  { to: '/challenges/view', label: 'Browse & edit challenges' },
  { to: '/metrics', label: 'User metrics & signups' },
  { to: '/carousel', label: 'App home carousel' },
  { to: '/homepage', label: 'Homepage challenge order' },
  { to: '/subscriptions', label: 'Challenge subscriptions' },
  { to: '/user', label: 'Look up a user' },
];

export default function Dashboard() {
  const [attrs, setAttrs] = useState<Record<string, string> | null>(null);

  useEffect(() => {
    fetchUserAttributes()
      .then((a) => setAttrs(a as Record<string, string>))
      .catch(() => setAttrs({}));
  }, []);

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight text-ink">
          Welcome
        </h1>
        <p className="mt-1 text-ink-muted">
          {attrs?.email
            ? `Signed in as ${attrs.email}`
            : 'Manage challenges, content, and analytics via API Gateway.'}
        </p>
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        {links.map(({ to, label }) => (
          <Link
            key={to}
            to={to}
            className="group flex items-center justify-between rounded-xl border border-slate-200/80 bg-white px-4 py-4 shadow-soft transition hover:border-brand/40 hover:shadow-md"
          >
            <span className="font-medium text-ink">{label}</span>
            <ArrowRight className="h-4 w-4 text-ink-muted transition group-hover:translate-x-0.5 group-hover:text-brand" />
          </Link>
        ))}
      </div>
    </div>
  );
}
